module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Seedorf_UR-8c830cf2f50454e2e87c46058fc9ed2f.svg";